const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const ID = `(?:\\d+|${UUID})`;

// A whole path segment that IS an id, or a slug segment ending in "-<id>"
// (e.g. `acme-corp-12345`). The whole segment is replaced with `:id`, which
// also drops the human-readable name slug (itself identifying). `[^/?#]*`
// never crosses a segment, query, or fragment boundary. Terminator allows
// `/`, `?`, `#`, or end-of-string so ids right before a query/fragment match.
const PATH_ID_SEGMENT = new RegExp(`/(?:[^/?#]*-)?${ID}(?=[/?#]|$)`, 'gi');

// An id value in a query string / fragment, e.g. `?dealId=123` or `?id=<uuid>`.
const QUERY_ID_VALUE = new RegExp(`=${ID}(?=[&#]|$)`, 'gi');

/**
 * Replace entity identifiers (numeric or UUID) with `:id`, in both path
 * segments (including ids embedded in `name-<id>` slugs) and query-string
 * values. Keeps RUM view urls / action names groupable and prevents leaking
 * deal/fund/company identifiers (and name slugs) into Datadog.
 *
 * Known, accepted tradeoff: a meaningful bare-numeric path segment (e.g. a
 * year `/2024/`) is also scrubbed to `:id`. This only reduces view grouping
 * granularity; it never leaks data, and the app's browser routes do not use
 * bare numeric non-id segments.
 */
export function scrubIds(value: string | undefined): string | undefined {
  if (!value) {
    return value;
  }
  return value.replace(PATH_ID_SEGMENT, '/:id').replace(QUERY_ID_VALUE, '=:id');
}
